var _mask, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLoader = function SvgLoader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon 16x16/loader"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle loader"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6061_15046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_6061_15046_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_6061_15046)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.008 0 0 0.008 8 8)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1375,
    y: -1375,
    width: 2750,
    height: 2750
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(179, 179, 179, 1) 0deg,rgba(37, 37, 37, 1) 0.263837deg,rgba(179, 179, 179, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 10.7614 10.7614 13 8 13V19C14.0751 19 19 14.0751 19 8H13ZM8 13C5.23858 13 3 10.7614 3 8H-3C-3 14.0751 1.92487 19 8 19V13ZM3 8C3 5.23858 5.23858 3 8 3V-3C1.92487 -3 -3 1.92487 -3 8H3ZM8 3C10.7614 3 13 5.23858 13 8H19C19 1.92487 14.0751 -3 8 -3V3Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.14721146225929260,\"g\":0.14721146225929260,\"b\":0.14721146225929260,\"a\":1.0},\"position\":0.00073287915438413620},{\"color\":{\"r\":0.70196080207824707,\"g\":0.70196080207824707,\"b\":0.70196080207824707,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.14721146225929260,\"g\":0.14721146225929260,\"b\":0.14721146225929260,\"a\":1.0},\"position\":0.00073287915438413620},{\"color\":{\"r\":0.70196080207824707,\"g\":0.70196080207824707,\"b\":0.70196080207824707,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":16.0,\"m01\":0.0,\"m02\":0.0,\"m10\":0.0,\"m11\":16.0,\"m12\":0.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_6061_15046)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_6061_15046_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 10.7614 10.7614 13 8 13V19C14.0751 19 19 14.0751 19 8H13ZM8 13C5.23858 13 3 10.7614 3 8H-3C-3 14.0751 1.92487 19 8 19V13ZM3 8C3 5.23858 5.23858 3 8 3V-3C1.92487 -3 -3 1.92487 -3 8H3ZM8 3C10.7614 3 13 5.23858 13 8H19C19 1.92487 14.0751 -3 8 -3V3Z",
    mask: "url(#path-1-inside-1_6061_15046)"
  })))));
};
export default SvgLoader;